//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/**
 * Returns the names of the enumerable string properties and methods of an object.
 *
 * (This is Object.keys but with better type inference for key names)
 * @param o Object that contains the properties and methods.
 */
export default function getKeys<T extends Record<string, unknown>>(
  obj: T,
): (keyof T)[] {
  return Object.keys(obj);
}
